module.exports = __webpack_public_path__ + "img/more.ddda8ff3.png";